import { PHeadline } from '@porsche-design-system/components-react'
import React from 'react'

import { ReportingContext } from '../../../../utils/Context/ReportingContext'
import { headlinesAppList } from '../../../../utils/ratingService'
import Panel from '../../../Panel/Panel'
import TableWithAction from '../TableWithAction/TableWithAction'

import { PortalContext, UserRole } from '../../../../utils/PortalContext'

type DataSorting = {
  additionalInformation: any
  col0: string
  col1: string
  col2: string
}

type Props = {
  content: DataSorting[]
  loading: boolean
}

const TableApplications: React.FC<Props> = ({ content, loading }) => {
  const {
    setChosenDepartment,
    setDepartmentButton,
    filter,
    setFilter,
    setContentHeader,
    setResetParams,
    setAppId,
    setOpenSubApps,
    setChosenApplication,
    setApplicationButton,
    setShowSingleRatings,
    setCellContentAppWithSubApps
  } = React.useContext(ReportingContext)
  const { userRole } = React.useContext(PortalContext)

  const [data, setData] = React.useState(content)

  const rowClickHandler = (item: any) => {
    setCellContentAppWithSubApps([])
    setAppId(item.additionalInformation.app)
    setOpenSubApps(true)
    setFilter({ ...filter, app: [item.additionalInformation.app], department: [] })
    setChosenDepartment('')
    setDepartmentButton('Alle Abteilungen')
    setChosenApplication(item.col0)
    setContentHeader(item.col0)
    setApplicationButton(item.col0)
    setResetParams(true)

    userRole === UserRole.Manager && setShowSingleRatings(true)
    userRole === UserRole.KeyUser && setShowSingleRatings(true)
  }

  React.useEffect(() => {
    setData(content)
  }, [content])

  React.useEffect(() => {
    if (loading) {
      setData([])
    }
  }, [loading])

  return (
    <>
      <PHeadline variant='headline-5'>Applikationen</PHeadline>
      <Panel withMargin withPadding>
        <TableWithAction
          caption='Applikationen'
          content={data}
          headlines={headlinesAppList}
          loading={loading}
          rowClicker={rowClickHandler}
        />
      </Panel>
    </>
  )
}

export default React.memo(TableApplications)
